import React from 'react';
import { Popover, Button, Select, Icon, Tooltip, Checkbox } from 'antd';

const { Option } = Select;

export const UsageUrl = ({ onChange, urls = [], params }) => {
  const changeSort = () => {
    let order;

    if (params?.order === '') {
      order = 'asc';
    } else if (params?.order === 'asc') {
      order = 'desc';
    } else {
      order = '';
    }

    onChange({ ...params, order });
  };

  const content = (
    <>
      <div style={{ marginBottom: 8 }} onClick={changeSort}>
        <b style={{ marginRight: 5 }}>Sort:</b>
        {!params?.order && <Icon type='column-height' />}
        {params?.order === 'asc' && <Icon type='sort-ascending' />}
        {params?.order === 'desc' && <Icon type='sort-descending' />}
      </div>
      <div style={{ marginBottom: 8 }}>
        <Checkbox
          onChange={(e) => {
            if (e.target.checked) {
              onChange({ ...params, value: urls });
            } else {
              onChange({ ...params, value: [] });
            }
          }}
          checked={urls.every((url) => (params?.value || []).includes(url))}
        >
          All
        </Checkbox>
      </div>
      <Select
        value={params?.value}
        mode='multiple'
        style={{ width: '150px' }}
        showSearch
        filterOption={(input, option) =>
          option.props.children.toLowerCase().startsWith(input.toLowerCase())
        }
        onChange={(value) => {
          onChange({ ...params, value });
        }}
        allowClear
        placeholder='Usage URL'
      >
        {urls.map((url) => (
          <Option key={url} value={url}>
            <Tooltip title={url}>
              {url.replace('http://', '').replace('https://', '')}
            </Tooltip>
          </Option>
        ))}
      </Select>
    </>
  );

  return (
    <Popover content={content} title='Usage URL' trigger='click'>
      <Button className='sighting-filter'>
        Usage URL
        <Icon type='down' style={{ color: '#d9d9d9' }} />
      </Button>
    </Popover>
  );
};
